module.exports = __webpack_public_path__ + "assets/b5bca5be19fb46a3eb658a0dc2f71763.mp3";